
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[...details]",
      function () {
        return require("private-next-pages/jobs/[...details].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/[...details]"])
      });
    }
  